import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import SummaryMainScore    from './parts/main-score';
import SummaryGroupScore   from './parts/group-score';
import SummaryCheckDraft   from './parts/check-draft';
import SummaryProjectsLogs from './parts/projects-logs';
import SummaryCheckInsight from './parts/check-insight';
// -------------------------------------------------------

class Summary extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    
    return (
      <div className="project-summary">
        <div className="summary-contents">
          
          <div className="summary-contents-left">
            <SummaryMainScore data={data} />
            
            <h2 className="summary-column">インフルエンサー ({Object.keys(workflow.influencers).length})</h2>
            <SummaryGroupScore data={data} />
            
            {( data.check_draft.length > 0 || data.all_draft_count > 0 ) && <h2 className="summary-column">下書き確認 ({data.check_draft.length})</h2> }
            <SummaryCheckDraft data={data} />
            
            <SummaryCheckInsight data={data} />
          </div>
          
          <div className="summary-contents-right">
            
            <SummaryProjectsLogs data={data} />
            
          </div>
          
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Summary;